module.exports = __webpack_public_path__ + "img/xiaobiaoshuiliang.aca3a89b.svg";